import { SB } from '@play-co/replicant';

export const gachaSchema = {
  gacha: SB.object({
    lastRoll: SB.object({
      items: SB.array(
        SB.union([
          SB.object({
            type: SB.tuple(['decoration']),
            tier: SB.int().min(0),
            tierId: SB.string(),
            id: SB.string(),
            image: SB.string().optional(),
            name_en: SB.string(),
            name_jp: SB.string(),
            theme: SB.string(),
            room: SB.string(),
          }),
          SB.object({
            type: SB.tuple(['accessory']),
            tier: SB.int().min(0),
            tierId: SB.string(),
            id: SB.string(),
            image: SB.string().optional(),
            name_en: SB.string(),
            name_jp: SB.string(),
            theme: SB.string(),
          }),
          SB.object({
            type: SB.tuple(['pet']),
            tier: SB.int().min(0),
            id: SB.string(),
            species: SB.string(),
            level: SB.int().min(0),
            name_en: SB.string(),
            name_jp: SB.string(),
            boostType: SB.string(),
          }),
        ]),
      ),
      rerolls: SB.int().min(0),
      gachaId: SB.string(),
    }).optional(),
  }).optional(),
};
